import { Route } from 'react-router-dom';

// Routes centralisées des différentes sections
import DataRoutes from '@app/Modules/data/routes';
import ViewRoutes from '@app/Modules/view/routes';
import CollaborateurRoutes from '@app/Modules/collaborateur/routes';
import ActionRoutes from '@app/Modules/action/routes';

export default [
    // Route centralisée pour la section "data"
    <Route
        key="data-routes"
        path={`/tables/data/*`}
        element={<DataRoutes />}
    />,

    // Route centralisée pour la section "view"
    <Route
        key="view-routes"
        path={`/tables/view/*`}
        element={<ViewRoutes />}
    />,

    // Route centralisée pour la section "collaborateur"
    <Route
        key="collaborateur-routes"
        path={`/tables/user/*`}
        element={<CollaborateurRoutes />}
    />,

    // Route centralisée pour la section "action"
    <Route
        key="action-routes"
        path={`/actions/*`}
        element={<ActionRoutes />}
    />,
];
